import { Injectable, inject } from '@angular/core';
import { SessionService } from './session.service';
import { LocalStorage } from '../enums';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { UtilsService } from './utils.service';
import { CONSTANTS_TOKEN } from '../config';
import { CameraCleanupService } from './camera-cleanup.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly sessionService = inject(SessionService);
  private readonly router = inject(Router);
  private readonly http = inject(HttpClient);
  private readonly msalService = inject(MsalService);
  private readonly utils = inject(UtilsService);
  private readonly constants = inject(CONSTANTS_TOKEN);
  private readonly cameraCleanup = inject(CameraCleanupService);

  private baseUrl: string = this.constants.api.baseUrlAuth;

  private _user = new BehaviorSubject({});
  public get user$(): BehaviorSubject<any> {
    return this._user;
  }
  public get user(): any {
    return this._user.value;
  }
  public set user(obj: any) {
    this._user.next({ ...obj });
  }

  // Subject to notify components before logout
  private _beforeLogout = new Subject<void>();
  public get beforeLogout$(): Observable<void> {
    return this._beforeLogout.asObservable();
  }

  getUser(updatedUser: any = null): any {
    const userInfo = {
      ...(this.sessionService.getItem(LocalStorage.UserInfo) || {}),
      ...(updatedUser && { user: updatedUser })
    };
    if (updatedUser) {
      this.sessionService.setItem(LocalStorage.UserInfo, userInfo);
      this.user = updatedUser;
    }
    return userInfo;
  }

  getUserInfo(): any {
    const userInfo: any = this.sessionService.getItem(LocalStorage.UserInfo);

    return userInfo;
  }

  updateFaceRegistration(faceRegistration: any): void {
    const userInfo = this.sessionService.getItem(LocalStorage.UserInfo) || {};
    (userInfo as any).faceRegistration = faceRegistration;
    this.sessionService.setItem(LocalStorage.UserInfo, userInfo);
  }

  getFaceRegistration(): any {
    const userInfo: any = this.sessionService.getItem(LocalStorage.UserInfo);
    return userInfo?.faceRegistration || null;
  }

  getUserCurrentLanguage(): string {
    const currentLanguage: any = this.sessionService.getItem(LocalStorage.CurrentLanguage);
    return currentLanguage;
  }

  logoutUser(invalidateApiSession: boolean = true): void {
    this._beforeLogout.next();
    this.sessionService.clear();
    this.cameraCleanup.stopAllMediaStreams();
    setTimeout(() => {
      this.cameraCleanup.stopAllMediaStreams();
      if (invalidateApiSession) {
        this.post(this.utils.getEncryptedUrls(this.constants.api.privateEndpoints.logout), {}).subscribe();
      }
      this.msalService.initialize().subscribe(() => {
        this.msalService.logout({
          onRedirectNavigate: () => false
        });
      });
      this.router.navigate(['auth', 'login']);
    }, 200);
  }

  get(url: string, options: any = {}): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}${url}`, options);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  post(url: string, payload: any, options: any = {}): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}${url}`, payload, options);
  }
}
